export const GET_PRODUCTS_OPTIONS = 'productOptions/GET_PRODUCTS_OPTIONS';

export const SET_PRODUCTS_OPTIONS = 'productOptions/SET_PRODUCTS_OPTIONS';

export const SET_PREDEFINED_COVER_IMAGES =
  'productOptions/SET_PREDEFINED_COVER_IMAGES';
